export default __webpack_public_path__ + "static/media/Prototype.5c59cf04.jpg";